import { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';

type ButtonProps<TCommonProps extends Record<string, unknown>> = TCommonProps & ButtonHTMLAttributes<HTMLButtonElement>;
type LinkProps<TCommonProps extends Record<string, unknown>> = TCommonProps &
  AnchorHTMLAttributes<HTMLAnchorElement> & {
    isExternal?: boolean;
  };

export type ButtonOrLinkProps<TCommonProps extends Record<string, unknown>> =
  | ButtonProps<TCommonProps>
  | LinkProps<TCommonProps>;

export const isLink = <TCommonProps extends Record<string, unknown>>(
  props: ButtonProps<TCommonProps> | LinkProps<TCommonProps>,
): props is LinkProps<TCommonProps> => 'href' in props;
